module.exports = {"141024100":"大槐树镇","141024101":"甘亭镇","141024102":"曲亭镇","141024103":"苏堡镇","141024104":"广胜寺镇","141024105":"明姜镇","141024106":"赵城镇","141024107":"万安镇","141024108":"刘家垣镇","141024109":"辛村镇","141024200":"淹底乡","141024201":"兴唐寺乡","141024202":"堤村乡","141024204":"龙马乡","141024207":"山目乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141024.json
// module id = 453
// module chunks = 0